import React from 'react';
import Modal from '../../../../components/Modal';

interface ManageProductsPromptModalProps {
  isOpen: boolean;
  wheelName: string;
  onConfirm: () => void;
  onSkip: () => void;
}

const ManageProductsPromptModal: React.FC<ManageProductsPromptModalProps> = ({
  isOpen,
  wheelName,
  onConfirm,
  onSkip
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onSkip} title="Gerenciar Produtos?" size="sm">
      <div className="space-y-4">
        <div className="p-4 rounded-lg bg-musgo/10 border border-musgo/30">
          <p className="text-sm text-tinta leading-relaxed">
            Sorteio <strong className="font-display italic text-bordo">"{wheelName}"</strong> foi salvo com sucesso! Deseja gerenciar os produtos agora?
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-end gap-3 pt-2">
          <button
            onClick={onSkip}
            className="w-full sm:w-auto px-4 py-2 border border-tinta/15 rounded-lg text-sm font-semibold text-tinta-soft bg-white hover:bg-creme-light hover:text-tinta focus:outline-none focus:ring-2 focus:ring-bordo/30 transition-colors"
          >
            Não, obrigado
          </button>
          <button
            onClick={onConfirm}
            className="w-full sm:w-auto px-4 py-2 rounded-lg text-sm font-bold text-creme bg-bordo hover:bg-bordo-dark focus:outline-none focus:ring-2 focus:ring-bordo/40 transition-colors"
          >
            Sim, gerenciar produtos
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ManageProductsPromptModal;
